import React, { useState, useEffect } from 'react';
import Box from '@mui/material/Box';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Typography from '@mui/material/Typography';
import TextField from '@mui/material/TextField';
import { getNumberComma } from '../../utils/numberUtils';
import _ from 'lodash';
import { monthPercent } from '../../utils/constCodeUtils';

const UserGoalTable = ({ formik, monthGoals, onChangeGoals, onAutoDisHandler  }) => {
  // Local state to handle editable goals
  const [editableGoals, setEditableGoals] = useState([]);

  useEffect(() => {
    if (Array.isArray(monthGoals)) {
      setEditableGoals(monthGoals);
    }
  }, [monthGoals]);

  const handleChange = (month, field, value) => {
    const updated = editableGoals.map(g =>
      g.month === month ? { ...g, [field]: value } : g
    );
    setEditableGoals(updated);
    onChangeGoals?.(updated);
  };

  // // Handler for updating a field in a specific month's goal
  // const handleChange = (month, field, value) => {
  //   const updated = editableGoals.map((g) =>
  //     g.month === month ? { ...g, [field]: value } : g
  //   );
  //   setEditableGoals(updated);
  //   if (onChangeGoals) {
  //     onChangeGoals(updated);
  //   }
  // };

  // Recalculate sums based on edited values
  const ptargetSalesSum = _.sumBy(editableGoals, 'ptargetSales');
  const ptargetSalesProfitSum = _.sumBy(editableGoals, 'ptargetSalesProfit');

  if (!editableGoals || !editableGoals.length) {
    return null;
  }

  return (
    <TableContainer component={Box}>
      <Table size="small">
        <TableHead>
          <TableRow>
            <TableCell align="center">월</TableCell>
            <TableCell align="center">목표 매출</TableCell>
            <TableCell align="center">목표 매출 이익</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {editableGoals.map((goal) => (
            <TableRow
              key={goal.month}
              sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
            >
              <TableCell component="th" scope="row" align="center">
                <Typography variant="subtitle2" color="text.primary" component="span">
                  {goal.month}월
                </Typography>{' '}
                {/* <Typography variant="caption" color="text.secondary">
                  {monthPercent[goal.month - 1]}%
                </Typography> */}
              </TableCell>

              <TableCell align="right">
                <TextField
                  variant="standard"
                  value={goal.ptargetSales}
                  onChange={(e) => {
                    const val = e.target.value.replace(/\D/g, '');
                    handleChange(goal.month, 'ptargetSales', Number(val));
                  }}
                  inputProps={{
                    inputMode: 'numeric',
                    pattern: '[0-9]*',
                    style: { textAlign: 'right' },
                  }}
                />
              </TableCell>

              <TableCell align="right">
                <TextField
                  variant="standard"
                  value={goal.ptargetSalesProfit}
                  onChange={(e) => {
                    const val = e.target.value.replace(/\D/g, '');
                    handleChange(goal.month, 'ptargetSalesProfit', Number(val));
                  }}
                  inputProps={{
                    inputMode: 'numeric',
                    pattern: '[0-9]*',
                    style: { textAlign: 'right' },
                  }}
                />
              </TableCell>
            </TableRow>
          ))}

          <TableRow>
            <TableCell align="center">총합</TableCell>
            <TableCell align="right">{getNumberComma(ptargetSalesSum)}</TableCell>
            <TableCell align="right">{getNumberComma(ptargetSalesProfitSum)}</TableCell>
          </TableRow>
        </TableBody>
      </Table>
    </TableContainer>
  );
};

export default UserGoalTable;
